module.exports = __webpack_public_path__ + "img/setting-active.291afdbc.svg";